// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-large-badge-6c4dc72e"};